import ApiServiceBase from "./ApiServiceBase";

const ElnApiService: ApiServiceBase = new ApiServiceBase("/api/v1/");

export default ElnApiService;
